import { useNavigate } from "react-router-dom";
import { PortalHeader } from "@/shared/layout/PortalHeader";
import { useAdminAuthStore } from "@/stores/adminAuthStore";

interface AdminHeaderProps {
  title?: string;
  description?: string;
}

function getInitials(name: string) {
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.charAt(0) ?? "";
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : "";
  return `${first}${last}`.toUpperCase() || "A";
}

export function AdminHeader({ title, description }: AdminHeaderProps) {
  const admin = useAdminAuthStore((s) => s.user);
  const signOut = useAdminAuthStore((s) => s.signOut);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut();
    navigate("/admin/signin", { replace: true });
  };

  return (
    <PortalHeader
      title={title ?? `Welcome back, ${admin?.name ?? "Admin"}`}
      description={description ?? "Monitor registered patients and account activity"}
      avatarInitials={admin ? getInitials(admin.name) : "A"}
      menuItems={[{ label: "Logout", onClick: handleLogout, danger: true }]}
    />
  );
}
